import { useDocumentTitle } from '~src/hooks/useDocumentTitle';
import styles from "../privacyPolicy/index.module.less";
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';

const UserAgreement = () => {
  useDocumentTitle('用户协议');
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [])

  const history = useNavigate();

  function toPrivacyPolicy() {
    history("/privacy_policy");
  }

  return <div className={styles.container}>
    <span
      className={styles.title}
      style={{ marginTop: '20px', textAlign: 'center' }}
    >
      用户协议
    </span>
    <span className={styles.paragraph} style={{ fontStyle: 'italic', textAlign: 'right' }}>
      发布日期：<span className={styles.word}>【2023】</span>年
      <span className={styles.word}>【05】</span>月
      <span className={styles.word}>【25】</span>日
    </span>
    <span className={styles.paragraph}>
      欢迎访问妙投信息科技（上海）有限公司运营的绿喵客户端（包括绿喵网站、小程序和App，以下简称<span className={styles.word}>“我们”</span>或<span className={styles.word}>“绿喵”</span>）。本《用户协议》规定了您访问和使用绿喵及我们通过绿喵提供的任何服务（以下统称<span className={styles.word}>“服务”</span>）的相关条款。<span className={styles.underline}>请仔细阅读这些条款，如果您对本《用户协议》有任何异议，请勿使用绿喵及任何服务。如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解本《用户协议》，并征得法定监护人的同意后使用绿喵及相关服务。</span>
    </span>
    <span className={styles.paragraph}>
      我们保留随时对本《用户协议》进行修改的权利。一旦本《用户协议》的内容发生变动，我们将会在绿喵上公布修改后的协议内容，我们也可能选择通过其他适当方式（比如系统通知）向您通知修改内容。
      <span className={styles.underline}>如果您拒绝接受用户协议的任何变更，请务必停止使用绿喵</span>。在本《用户协议》中，<span className={styles.word}>“用户”</span>和<span className={styles.word}>“您”</span>指绿喵的每位访客。绿喵以中文为主要语言。
    </span>
    <span className={styles.paragraph}>
      如果您订购或使用积分兑换/抵扣绿喵提供的任何服务或商品，或参与相关公益活动，可能还需要遵守此类服务适用的其他条款和条件（以下简称<span className={styles.word}>“服务条款”</span>），我们将在您使用时告知您该等条款和条件。您在申请注册流程中同意本《用户协议》之前，应当认真阅读本《用户协议》。如您自主选择同意或使用绿喵及相关服务，则视为您已充分理解本《用户协议》，并同意作为本《用户协议》的一方当事人接受本《用户协议》以及其他与绿喵及相关服务相关的协议和规则（包括但不限于绿喵《隐私政策》）的约束。
    </span>
    <span className={styles.title}>
      绿喵客户端和服务
    </span>
    <span className={styles.paragraph}>
      您须在绿喵客户端上注册才能获取和使用服务，或参与相关活动。此外，绿喵保留在未事先通知的情况下，限制用户获取或使用某些服务（或服务的任何功能），或设置其他绿喵自行决定的限制条件的权利。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>我们不能保证访问或使用客户端或服务时不会出现中断或错误，对于非由于我们的过错或者重大过失导致的客户端和服务的任何功能无法访问或无法使用的情形，绿喵不承担任何责任。</span>为满足用户需要或因技术或其他原因，绿喵可在不事先通知或说明原因的情况下随时扩展、限制或修改客户端及其功能。我们也可在不事先通知的情况下随时自行决定临时性或永久性停止提供任何或所有客户端或服务。服务（或服务的功能）可能因国家/地区而异。我们不保证或声明所有用户都能取得某项服务或服务的某项功能特性，或取得的服务或其功能特性的类型和范围相同。绿喵可自行决定限制或拒绝不同用户获取和使用的服务（或服务功能），或为不同用户创设不同的服务（或服务功能）获取和使用级别。
    </span>
    <span className={styles.paragraph}>
      为获取客户端或其服务的某些内容或功能，用户可能需要升级或更新其计算机系统中的硬件或软件。若因用户系统、互联网或其他原因造成客户端或服务部分或全部无法访问，绿喵不承担任何责任。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>（一）绿喵客户端简介</span><br />
      绿喵是一款助力环保公益的客户端软件，用户通过步行、骑行、自带咖啡杯、电动车充电等其他低碳环保行为，可兑换环保生态项目，或者环保时尚产品。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>（二）绿喵提供的服务内容说明</span><br />
      一、积分获取<br />
      1、每日签到：每日签到可获得绿喵积分。<br />
      2、邀请好友：每成功邀请1位未注册过绿喵的用户进入客户端完成注册并绑定手机号，将获得积分。<br />
      3、步行、骑行、自带咖啡杯等：通过步行、骑行、自带咖啡杯、电动车充电等多种低碳行为获得对应积分。<br />
      4、违规处罚：若出现不正当手段（包括但不限于批量注册、用户机器注册账户、作弊、扰乱系统等）获取的积分，经核实后，绿喵有权取消用户已获得积分，并对账号进行封禁，同时追究法律责任。
    </span>
    <span className={styles.paragraph}>
      二、绿喵积分消耗方式<br />
      1、用户可在绿喵客户端内的福利区域兑换礼品，根据商品兑换规则减扣相应积分。<br />
      2、用户可在绿喵客户端中参与公益或环保项目捐助，捐助完成后将减扣相应积分。<br />
    </span>

    <span className={styles.paragraph}>
      三、绿喵积分规则<br />
      绿喵积分有有效期，用户应及时使用自己的绿喵积分，有效期规则请以客户端内展示为准。从用户在各类活动中获得的积分进入绿喵账户开始算起，超过有效期仍未被使用或者兑换的，则此部分过期积分将逾期失效并作归零处理。<br />
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>（三）绿喵福利商城订单及配送</span><br />
      用户在开始注册使用绿喵客户端时，应具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若不具备前述与您行为相适应的民事行为能力，则您与您的监护人应依照法律规定承担因此而导致的一切后果。
    </span>
    <span className={styles.paragraph}>
      关于订单：<br />
      1、在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。<br />
      2、您理解并同意：绿喵客户端上销售商展示的商品和价格等信息仅仅是要约邀请，您通过绿喵客户端下达要约邀请时须填写您希望购买的商品数量、收货人姓名、联系方式、收货地址等内容，系统据此生成完整的要约，在您填入这些信息时即代表您授权绿喵将这些信息为履行本协议之目的向第三方披露；绿喵收到您的要约信息后有权结合商品库存、交易的真实性与合理性、是否损害其他会员的利益等因素，合理判断是否与您就本订单商品确认合同关系；如发现您或者您的要约涉嫌不真实、不诚信或滥用会员权利等违反本协议约定等情形的，绿喵不会接受您的要约；如绿喵未接受您的要约的，如此时您已付款的，您会收到全额退款。<br />
      3、绿喵可能会基于商品库存、保护会员权益等因素对商品订购数量作出限制。您在发出要约时应注意真实、合理地消费。如您拟购买的商品发生缺货或超过订购限制数量的，绿喵会在配送前通知您后取消订单，您也有权自行取消订单。<br />
      4、您理解并同意：绿喵只服务于用户个人获取积分消费需求而提供服务，如您有使用绿喵客户端获取经济利益的行为，绿喵有权取消您的订单。绿喵对所售商品基于一般的商业规则进行定价并销售，若因故造成所售商品价格明显不符合一般的商业规则，您同意绿喵可以基于重大误解撤销与您的订单（无论订单是否已实际履行）。<br />
      5、您理解并同意：绿喵只允许每位用户使用唯一绿喵账户。如有证据证明或绿喵根据本用户协议判断您存在不当注册或不当使用多个绿喵账户的情形，绿喵可以采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给绿喵造成损失的，您还应承担赔偿责任。我们所发布的所有活动信息、优惠内容、购物项目，您仅可使用唯一的账户进行除访问、浏览外的参与和购物。我们会对您以多账号形式产生的上传、评价、订单等除访问、浏览外的功能进行限制。我们会以您的个人信息匹配的方式进行多账号情况的甄别，如出现以下情况之一：<br />
      （1）同一登录账号；<br />
      （2）同一注册手机号；<br />
      （3）同一支付账号；<br />
      （4）同一收货地址/多人使用相似地址（收货电话、收货姓名、收货门牌号）；<br />
      （5）同一IP地址；或<br />
      （6）其他合理显示为同一用户的情形，我们均视为同一用户，并仅向您提供基于一个账号的服务。<br />
    </span>
    <span className={styles.paragraph}>
      关于配送：<br />
      1、您在绿喵购买的商品将按照客户端上您所指定的送货地址进行配送。订单信息中列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。您应当清楚准确地填写您的送货地址、联系人及联系方式等配送信息，您知悉并确认，您所购买的商品应仅由您填写的联系人接受身份查验后接收商品，因您变更联系人或相关配送信息而造成的损失由您自行承担。<br />
      2、因如下情况造成订单延迟或无法配送等，绿喵将无法承担迟延配送的责任：<br />
      （1）客户提供错误信息和不详细的地址；<br />
      （2）货物送达无人签收，由此造成的重复配送所产生的费用及相关的后果；<br />
      （3）不可抗力，包括但不限于：自然灾害、交通戒严、突发战争、海关政策变动、传染病或流行疾病、地区物流政策变动等。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>（四）关于绿喵提供好友邀请功能</span><br />
      绿喵客户端提供邀请好友功能，用户可通过邀友功能，自愿分享客户端给您希望邀请的朋友，您的朋友可通过邀请链接注册绿喵，接受您的邀请，成为本产品中的好友。用户选择使用本功能应该预先知晓：对于您和您的朋友之间在相识、交往中所发生或可能发生的任何心理、生理上的伤害及/或经济上的损失，均属您个人行为。绿喵不承担任何责任。由于非故意及不可抗拒的原因（含系统维护和升级），导致的用户数据损失、服务停止，绿喵不承担赔偿及其他补充或连带的法律责任。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>遵守法律</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>您同意在购买和/或查看绿喵或服务的任何内容时遵守所有适用法律</span>。另外，绿喵客户端或服务禁止对某些地区的用户开放。您同意，购买和/或查看绿喵或服务的任何内容时，不会违反适用的数据导出法律。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>绿喵客户端的内容和服务限制</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>请您知悉，绿喵客户端或者服务中的信息可能由第三方提供，我们不保证客户端或服务中提供的该等信息的准确性、完整性或优质性，我们仅按“原样”提供“可用”信息，您应当自行对相关信息的真实性、可用性进行判断并自行承担可能产生的风险。绿喵客户端上提供的信息和投资、会计或法律分析策略（如有）既不全面也并非对每个人都适用。有些信息仅与中国大陆和香港相关，可能不符合其他国家的法律、法规或其他法律要求或与之无关。如果您想要使用这些信息，则您有责任确定此种使用是否在技术上和法律上在意图使用的地区可行，其可行性方案及范围。我们建议您在将任何信息用于个人、财务、会计、法律或商业用途前，先对该信息进行核实。另外，绿喵客户端发布的及服务过程中发布的意见和观点不代表绿喵或其管理层的意见或建议。我们可能在不事先通知或说明原因的情况下随时修改客户端的内容和服务。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>我们不保证绿喵或服务中的相关产品、商品的品质、功用或效果。对于绿喵中的相关公益活动，我们无法核实和确保相关公益活动的具体执行情况、捐赠基金的募集及使用情况以及公益活动的实现效果。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>使用绿喵内容和服务的许可</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}><span style={{ fontWeight: 'normal' }}>我们仅许可您本人在限定范围内访问和使用绿喵的内容和服务，前提是不得修改该内容并应完整保留全部所有权声明。</span>您不得复制、发布、翻译、合并、出售、出租、分发内容或在其他网站或绿喵客户端上制作其衍生品，也不得将之作为任何教育、培训或参考资料。您不得对绿喵和服务中获取的任何内容进行封装成帧或利用封装成帧技术进行处理。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>第三方内容</span>
    </span>
    <span className={styles.paragraph}>
      第三方在服务中提供的任何推荐、意见、建议、产品或服务报价（以下简称<span className={styles.word}>“第三方内容”</span>）（如有）仅为其各自供应商的报价，而非绿喵的报价，绿喵不保证该第三方内容的准确性、完整性、可靠性或有用性。<span className={styles.underline}>用户有责任对第三方内容进行评估，因用户信赖或以其他方式使用第三方内容造成的任何损害或损失，绿喵不承担任何责任。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>病毒</span>
    </span>
    <span className={styles.paragraph}>
      您理解并同意，在符合法律规定的情况下，绿喵对以下事由所导致的服务中断或终止或数据丢失、消除不承担责任：<br />
      （1）受到计算机病毒、木马或其他恶意程序、或其他可能具有污染性或破坏性的代码、黑客攻击的破坏；<br />
      （2）用户或绿喵的电脑软件、系统、硬件和通信线路出现故障。<br />
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>广告商</span>
    </span>
    <span className={styles.paragraph}>
      虽然我们寻求与优质公司合作，但是我们对广告商和赞助商的主张或声明（如有）不承担任何责任。绿喵不对客户端上出现的任何广告商或赞助商的任何产品或服务进行审查，亦不对其承担任何责任。因广告商或赞助商滥用您提供的任何个人信息或资料造成的任何类型的损害，我们概不负责。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>链接</span>
    </span>
    <span className={styles.paragraph}>
      为了方便客户，绿喵客户端和服务可能提供跳转至其他网站、客户端、小程序、App或资源（以下简称<span className={styles.word}>“第三方网站”</span>）的链接。由于我们无法审查或控制该等第三方网站提供的内容和服务，所以如果您使用或依赖此类第三方网站的任何内容、产品、服务或信息，绿喵不承担任何责任。绿喵和服务包含此类链接并不表示绿喵认可或认同链接的第三方网站、其运营商或所有者，或与之存在关联、附属或赞助关系。您选择某个链接时，就可能会离开绿喵客户端。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>禁止行为</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>严禁从事以下活动：</span>
    </span>
    <span className={styles.paragraph}>
      <ul>
        <li>
          出于非法或欺诈目的使用绿喵或服务（包括链接）；
        </li>
        <li>
          在绿喵上发布包含病毒或其他恶意或污染性、破坏性代码的资料；
        </li>
        <li>
          从事任何具有诽谤性、侵犯他人个人隐私权或侵犯他人权利的活动；
        </li>
        <li>
          将绿喵或服务用于非法、有害、威胁、侮辱、骚扰、侵权、诽谤、粗俗、淫秽、中伤、仇恨，贬低他人性别、种族、阶级、民族、国籍、宗教、性向、残疾等其他类型或其他负面的目的；
        </li>
        <li>
          对绿喵或服务进行复制、修改、逆向工程、反汇编等，或创作其衍生产品，或以其他方式试图找出绿喵或服务的任何源代码；
        </li>
        <li>
          删除或遮盖通过站点或服务获取的内容上的版权声明或其他声明；
        </li>
        <li>
          干扰或破坏绿喵的功能、服务或连接绿喵的服务器和网络，或者违背直接或间接连接绿喵的网络的任何要求、程序、政策或规定；
        </li>
        <li>
          为了（包括但不限于）越权访问绿喵或服务，以任何方式或形式修改绿喵或服务，或使用修改后的绿喵或服务；
        </li>
        <li>
          未经绿喵事先书面许可，以本用户协议未授权的方式或商业用途复制、打印、缓存、存储、封装成帧或分发绿喵或服务中检索的内容；
        </li>
        <li>
          出售、转让、再许可或以其他方式移转服务或绿喵内容的任何权利；
        </li>
        <li>
          通过非绿喵提供的界面访问站点或服务；
        </li>
        <li>
          使用绿喵或服务违反任何法律（无论地方、州/省/地区、国家法律还是国际法，无论是否有意）；
        </li>
        <li>
          冒充任何个人或实体，或虚假陈述或以其他方式歪曲您与任何个人或实体的关联关系；
        </li>
        <li>
          从事“屏幕抓取”，“数据库抓取”；
        </li>
        <li>
          协助违反本用户协议或隐私政策的行为。
        </li>
      </ul>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>如果任何用户违反了本《用户协议》的任何条款，或者绿喵有合理的理由认为用户违反了本《用户协议》的任何条款，包括任何用户从事了前述任何禁止活动，我们有权采取其认为适当的惩罚措施。此类惩罚措施包括但不限于：（i）绿喵可自行决定中止或终止用户的帐户及与该帐户有关的全部帐户，且我们对因此造成的任何损失或损害，概不承担责任；（ii）限制、降级、中止或终止订阅、访问或（当前或今后）使用任何服务；（iii）对您使用任何服务的任何功能或特性施加绿喵自行认为合理的其他限制；及（iv）绿喵自行认为必要或适当的任何其他纠正措施、惩罚或处罚。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>隐私保护</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>绿喵可能会收集某些用户的个人信息</span>。请查看我们的<span onClick={toPrivacyPolicy.bind(this)} className={styles.underline}>《隐私政策》</span>，了解我们如何处理您的个人信息、如何使用该信息、如何共享该信息以及您享有的与个人信息相关的权利。《隐私政策》系本《用户协议》的组成部分。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>反馈</span>
    </span>
    <span className={styles.paragraph}>
      我们欢迎用户就我们的服务给出的所有反馈、意见、创意、素材和建议（统称<span className={styles.word}>“反馈”</span>）。<span className={styles.underline}>您理解并同意，绿喵不放弃使用其此前或同时期已知的类似和/或相关反馈的任何权利</span>无论是由其员工、合同商开发，从其他来源获得还是由其他您提交的。<span className={styles.underline}>此外，您提交反馈即授予我们无限制、无偿使用该反馈的权利。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>所有权</span>
    </span>
    <span className={styles.paragraph}>
      绿喵及其内容受版权、商标和其他所有权法律的保护。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline} style={{ fontWeight: 'normal' }}>绿喵商标。</span>绿喵或服务中出现的所有绿喵徽标和/或商标都是我们的财产，未经我们明确书面同意不得使用。服务关联使用的所有其他商标、服务标志和徽标，无论是否署名，均为其各自所有者的商标、服务标志或徽标，未经其明确书面同意，不得使用。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline} style={{ fontWeight: 'normal' }}>版权侵权通知</span>。绿喵认真对待版权侵权索赔。我们会根据适用法律应对涉嫌版权侵权的通知。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline} style={{ fontWeight: 'normal' }}>反复侵害者</span>。如果您反复违反本用户协议，我们将根据政策在适当情况下禁止您访问绿喵和/或终止您的帐户。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>责任限制</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>免责声明：</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>绿喵和服务仅供参考之用。绿喵上的内容均不构成专业建议，无论是医疗、财务、法律还是其他方面。您使用绿喵、插件和服务须自行承担风险。绿喵客户端、插件、和服务均按“原样”提供并“可用”。绿喵不声明或保证其能满足您的需要，其安全、最新、准确无误且不会中断，或使用这些网站、插件和服务能获得准确、及时、有用或可靠的结果。在法律允许的最大范围内，我们拒绝以任何方式、出于任何目的就插件、客户端和服务的使用或其内容的准确性、完整性、时效性或通用性提供任何明示或暗示的保证、声明或条件，包括但不限于适销性、具体适用性和非侵权性等方面的保证和条件。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>间接损害免责：</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>在任何情况下，绿喵均不对因使用或无法使用插件、绿喵或其任何服务或内容，或资料丢失而导致的任何附带的、特别的、结果性的、惩罚性的或间接损害承担责任，即使我们已被告知此类损害的可能性，且无论是由于合同、侵权行为、疏忽大意、产品责任、严格责任还是其他原因。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>所有用户自行决定从绿喵或服务器下载或以其他方式获取任何资料并自担风险，并且对因下载此类资料给其自身或我们计算机系统造成任何损坏或任何资料丢失承担全部责任。用户从绿喵或通过使用绿喵获得的任何口头或书面建议或资料均不构成本用户协议未明确说明的任何保证。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>就用户在绿喵上购买、以积分兑换或抵扣或以其他方式获得的服务或产品，绿喵不对此类服务或产品做任何保证或声明。绿喵及其关联方也不承担此类服务或产品的任何责任。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>所有用户在此同意对绿喵、我们的关联方、董事、高管和员工因用户访问或使用绿喵或服务（包括但不限于在绿喵上展示该用户的信息），或因用户违反本《用户协议》的任何条件和条款引起的所有损失、索赔、赔偿责任（包括全额赔偿法律成本）进行赔偿，使其免受损害。所有用户在此进一步同意对绿喵、我们的关联方、董事、高管和员工因用户违背对我们所做声明和保证引起的所有损失、损害、索赔、赔偿责任（包括全额赔偿法律成本）进行赔偿，使其免受损害。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>尽管有任何前述规定，绿喵、我们的员工、代理商、关联方、代表或以我们的名义行事的任何人对于每位用户在任何日历年度因访问或使用绿喵或服务引起的全部索赔的累计赔偿责任不超过以下二者中的较小额：（a）用户在该年度向绿喵购买和使用绿喵或服务支付的费用金额；和（b）适用法律允许的最高金额。前述规定未免除用户证明其实际损害的责任。因使用绿喵或服务引起的所有索赔须在诉讼事由产生之日起一（1）年内或本条款适用法律规定的较长期限内提出。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>根据用户协议，您应承担的责任范围和免责限度为法律允许的最大范围，且无论绿喵是否收到通知或知悉造成此类损失的可能性，均应适用。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>一般条款</span>
    </span>
    <span className={styles.paragraph}>
      本用户协议及适用的服务条款构成用户与绿喵签订关于用户访问和使用站点及其服务的完整协议，并取代此前有关主题事宜的所有协议。
    </span>
    <span className={styles.paragraph}>
      本用户协议应遵照中华人民共和国法律进行解释并受其管辖。
    </span>
    <span className={styles.paragraph}>
      凡因本用户协议引起或与之相关的纠纷、争议或索赔，包括涉及其产生、效力、解释或终止（以下简称<span className={styles.word}>“争议”</span>）的任何问题，各方应通过友好协商解决。如果自一方当事人就争议产生事宜书面通知另一方或多方当事人之日起三十（30）日之内未达成和解，该争议应提交上海国际经济贸易仲裁委员会（以下简称“SHIAC”）根据申请仲裁时有效的上海国际经济贸易仲裁委员会的仲裁规则进行仲裁并最终解决。仲裁庭由独任仲裁员组成，可以任命非上海国际经济贸易仲裁委员会仲裁员小组的仲裁员。如果当事人各方在一方当事人发出仲裁通知后二十（20）日内未就同意参与案件的仲裁员的任命达成一致意见，上海国际经济贸易仲裁委员会应指定一名仲裁员。仲裁程序应采用中文在中国上海进行。仲裁裁决为终局裁决，对双方均具有约束力。
    </span>
    <span className={styles.paragraph}>
      用户或绿喵未行使任何权利或执行本用户协议的任何条款不构成对该权利或条款的放弃。如果有管辖权的法院认为本用户协议的任何条款无效或不可执行，法院应在可能的范围内实行该条款反映的目的，且本用户协议的其他条款继续有效。
    </span>
    <span className={styles.paragraph}>
      如果本用户协议的任何条款无效或不可执行，则应删除该条款，而其他条款仍然有效并应得到执行。
    </span>
    <span className={styles.paragraph}>
      在任何情况下，因我们无法合理控制的不可抗力、武力或原因，包括但不限于互联网故障、计算机、电信或其他设备故障、电力故障、罢工、劳资纠纷、暴动、叛乱、内乱、劳动力或物资短缺、火灾、洪水、暴风雨、爆炸、天灾、战争、政府行为、国内或国外法院或法庭的命令，或第三方违约行为，直接或间接导致通过绿喵访问或交付的内容或服务延迟、失败或中断，绿喵均不承担责任。
    </span>
    <span className={styles.paragraph}>
      <span className={styles.underline}>绿喵有权基于业务调整等需要，将本用户协议（包括将条款规定的我们的所有权利、所有权、收益、利益及义务和责任）转让给任何个人或实体（包括我们的任何关联方），在前述转让情形发生时，我们将会通过绿喵客户端向您告知或者说明。未经绿喵事先书面同意，您不得将本用户协议全部或部分转让给任何人或实体。</span>
    </span>
    <span className={styles.paragraph}>
      <span className={styles.word}>联系我们</span>
    </span>
    <span className={styles.paragraph}>
      如您对本《用户协议》有任何问题或建议，请发送邮件至<span className={styles.email}>lvmiao@miotech.com</span>，与我们联系。我们将尽快审核您咨询的问题，并在验证您的身份后的十五（15）天内或法律法规规定期限内予以回复。
    </span>
    <span className={styles.paragraph} style={{ textAlign: 'right' }}>
      妙投信息科技（上海）有限公司
    </span>
  </div>
}
export default UserAgreement;
